import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { ArrowLeft, ArrowRight } from 'react-feather';
import styled from 'styled-components';

import { isEmpty } from 'lodash';
import { checkUrlLocale } from '../../utils/check-url-locale';
import { cleanInternalUrl } from '../../utils/clean-internal-url';
import { primaryButtonStyles, secondaryButtonStyles, whitepaperButtonStyles } from './component-styles/button';
import { primarylinkstyles, secondarylinkstyles } from './component-styles/link';
import { animation } from '../styles';

const propTypes = {
  to: PropTypes.string,
  linkstyle: PropTypes.string,
  withArrow: PropTypes.bool,
  backArrow: PropTypes.bool,
  hoverUnderline: PropTypes.bool,
  children: PropTypes.any
};

const InternalLink = props => {
  const {
    to,
    linkstyle = 'primary-link',
    withArrow = false,
    backArrow = false,
    hoverUnderline = false,
    children,
    ...allProps
  } = props;

  const trailingSlash = new RegExp('[/]$');
  const externalSite = new RegExp('https://www.(?!credera.com)');
  const tidyTo = !to
    ? null
    : externalSite.test(to) // if InternalLink is given a route pointing to an external site
    ? to.replace(trailingSlash, '')
    : !isEmpty(to) && to !== '/'
    ? checkUrlLocale() + cleanInternalUrl(to)?.replace(trailingSlash, '')
    : checkUrlLocale() + cleanInternalUrl(to); // handle null to prevent creating dead link

  return (
    <StyledLink linkstyle={linkstyle} to={tidyTo} $hoverUnderline={hoverUnderline} {...allProps}>
      {withArrow && backArrow && <LeftIcon className={'leftArrow'} size={20} />}
      {children}
      {withArrow && !backArrow && <RightIcon className={'rightArrow'} size={20} />}
    </StyledLink>
  );
};

const RightIcon = styled(ArrowRight)`
  margin-left: 4px;
`;

const LeftIcon = styled(ArrowLeft)`
  margin-right: 4px;
`;

const StyledLink = styled(Link)`
  ${({ linkstyle }) => {
    switch (linkstyle) {
      case 'primary-button':
        return primaryButtonStyles;
      case 'secondary-button':
        return secondaryButtonStyles;
      case 'whitepaper-button':
        return whitepaperButtonStyles;
      case 'primary-link':
        return primarylinkstyles;
      case 'secondary-link':
        return secondarylinkstyles;
      default:
        return primarylinkstyles;
    }
  }}

  svg {
    position: relative;
    transition: ${animation.general.transition};
  }

  &:hover {
    // https://styled-components.com/docs/api#transient-props - why the $ is used here
    text-decoration: ${({ $hoverUnderline }) => ($hoverUnderline ? 'underline' : '')};

    ${LeftIcon} {
      transform: translateX(-2px);
    }

    ${RightIcon} {
      transform: translateX(2px);
    }
  }
`;

InternalLink.propTypes = propTypes;

export { InternalLink };
